import { Component, Input } from '@angular/core';

@Component({
	selector: 'settings-btn',
	template: require('./settings-btn.html')
})
export class SettingsBtnComponent {
	@Input() text: string;
	@Input() isDisabled: boolean;

	constructor() {
		this.text = this.text || 'Settings';
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/buttons/settings-btn/settings-btn.ts